<template>
  <div 
    class="flex flex-row self-center relative justify-end items-center cursor-pointer mb-8 md:my-8 w-max max-w-10/12 md:max-w-7/12" 
    @click.stop="displayFieldList"
  >
    <div class="flex flex-row ml-auto items-end">
      <h5 class="text-indigo-600 font-normal">
        {{ prefixLibelle+(currentField+1)+'. '+options[currentField][libelleKeyInOptionsArray] }}
      </h5>
    </div>
    <div class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2">
      <icon
        class="h-4 w-4"
        name="chevron-down"
      />
    </div>

    <transition
      enter-active-class="duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        class="fieldlist flex z-20 mt-2 top-10 w-max max-w-full
                        absolute rounded-md bg-white shadow-md shadow-gray-600 text-base md:text-sm"
        v-click-outside="displayFieldList" 
        v-show="showList"
      >
        <div class="mx-5 my-3">
          <div class="text-left">
            <div 
              v-for="(field, i) in options" 
              :key="i"
              class="first:pt-2 py-2 md:py-1"
            >
              <p 
                class="text-gray-600 hover:text-gray-900" 
                @click="$emit('chooseItem', i)"
              >
                {{ prefixLibelle + (i+1) + ' : ' + field[libelleKeyInOptionsArray] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from './Icon.vue';
import ClickOutside from 'vue-click-outside';

export default {
  components:{
    Icon,
  },

  props:{
    prefixLibelle:{
      type: String,
      required: false,
      default:'',
    },
        
    currentField:{
      type: Number,
      required: true
    },

    options:{
      type: Array,
      required: true,
    },

    libelleKeyInOptionsArray:{
      type: String,
      required: true,
    }
  },

  data(){
    return {
      showList: false,
    };
  },

  methods:{
    displayFieldList(){
      this.showList = !this.showList;
    },
  },

  directives:{
    ClickOutside
  }
};
</script>